import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="!accepted" class="cookie-consent-banner">
      <span>
        Nous utilisons Google Analytics pour collecter des données de
        navigation. En continuant, vous acceptez l'utilisation des cookies.
      </span>
      <button (click)="acceptCookies()">J'accepte</button>
    </div>
  `,
  styles: [
    `
      .cookie-consent-banner {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background: #222;
        color: #fff;
        padding: 18px 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        font-size: 1rem;
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
        gap: 20px;
      }
      .cookie-consent-banner button {
        background: #4caf50;
        color: #fff;
        border: none;
        border-radius: 6px;
        padding: 8px 18px;
        font-weight: 600;
        cursor: pointer;
        margin-left: 10px;
        transition: background 0.2s;
      }
      .cookie-consent-banner button:hover {
        background: #087f23;
      }
    `,
  ],
})
export class CookieConsentComponent {
  accepted = localStorage.getItem('cookieConsent') === 'true';

  acceptCookies() {
    localStorage.setItem('cookieConsent', 'true');
    this.accepted = true;
  }
}
